var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25004L11.8735 1.25002L11.8735 1.25002C10.6715 1.24974 9.89579 1.24956 9.17012 1.48871C8.9464 1.56244 8.72847 1.65271 8.51813 1.75877C7.83591 2.10279 7.28749 2.65147 6.43775 3.5016L6.43775 3.5016L6.34835 3.59103L5.73508 4.2043C5.70579 4.23359 5.66607 4.25004 5.62465 4.25004C3.2086 4.25004 1.25 6.20864 1.25 8.6247L1.25 13L1.25 13.0565L1.25 13.0565C1.24998 14.8942 1.24997 16.3499 1.40313 17.4891C1.56076 18.6615 1.89288 19.6104 2.64124 20.3588C3.3896 21.1072 4.33855 21.4393 5.51098 21.5969C6.65019 21.7501 8.10583 21.7501 9.94359 21.75L10 21.75L14 21.75L14.0564 21.75L14.0565 21.75C15.8942 21.7501 17.3498 21.7501 18.489 21.5969C19.6614 21.4393 20.6104 21.1072 21.3588 20.3588C22.1071 19.6104 22.4392 18.6615 22.5969 17.4891C22.75 16.3498 22.75 14.8942 22.75 13.0565L22.75 13L22.75 8.6247C22.75 6.20864 20.7914 4.25004 18.3753 4.25004C18.3339 4.25004 18.2942 4.23359 18.2649 4.2043L17.6516 3.59103L17.5622 3.5016C16.7125 2.65146 16.1641 2.10279 15.4819 1.75877C15.2715 1.65271 15.0536 1.56244 14.8299 1.48871C14.1042 1.24956 13.3285 1.24974 12.1265 1.25002L12.1265 1.25002L12 1.25004ZM16 12.0001C16 14.2092 14.2091 16 12 16C9.79086 16.0001 8 14.2092 8 12C8 9.79091 9.79086 8.00005 12 8.00005C14.2091 8.00005 16 9.79091 16 12.0001Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic_camera.4c229b0a7299e5a7760e6ebc12eb6193.svg";
export { ForwardRef as ReactComponent };